import { ProductDto, ProductUnitDto, ShoppingCartItemDto } from '@/api';
import Big from 'big.js';

export const PriceService = {

  ROUNDING_MODE_HALF_UP: 1,

  findEffectivePrice(product: ProductDto): Big | null {
    if (product.effectivePrice) {
      return new Big(product.effectivePrice);
    } else {
      return null;
    }
  },
  findListPrice(product: ProductDto): Big | null {
    if (product.listPrice) {
      return new Big(product.listPrice);
    } else {
      return null;
    }
  },
  findUnitPrice(unit: ProductUnitDto, storagePrice: Big | null): Big | null {
    if (!storagePrice) {
      return null;
    }
    return storagePrice.mul(unit.ratio).round(2, this.ROUNDING_MODE_HALF_UP);
  },
  findEffectiveCartItemPrice(item: ShoppingCartItemDto): Big | null {
    if (!item || !item.unit || !item.product) {
      return null;
    }
    const unitPrice = this.findUnitPrice(item.unit, this.findEffectivePrice(item.product));
    return unitPrice ? unitPrice.mul(item.amount) : null;
  },
  findBasePrice(product: ProductDto, unit: ProductUnitDto): Big | null {
    const basePrice = product && product.basePrice;
    const storagePrice = PriceService.findEffectivePrice(product);
    if (!basePrice || !basePrice.quantity || !basePrice.refQuantity || !storagePrice || !unit || !unit.ratio) {
      return null;
    }
    const basePriceRatio = new Big(basePrice.refQuantity).div(basePrice.quantity);
    return storagePrice.mul(basePriceRatio);
  },
};
